/**
 * Tasting Journey Banner Module
 * Manages the Tasting Journey banner based on user's subscription products and country.
 */
window.TastingJourney = (function () {
  // Configuration (Product IDs per country)
  const CONFIG = {
    PT: {
      step1: [15380397162820],
      step2: [15380397556036],
      step3: [15380396671300],
    },
    ES: {
      step1: [15647997624693],
      step2: [15647998116213],
      step3: [15647997165941],
    },
    IT: {
      step1: [15645540417909],
      step2: [15645540581749],
      step3: [15647439815029],
    },
  };

  function getCountry() {
    if (window.LoopConfig && window.LoopConfig.countryCode) {
      return window.LoopConfig.countryCode;
    }

    if (window.Shopify && window.Shopify.country) {
      return window.Shopify.country;
    }

    const hostname = window.location.hostname;
    if (hostname.includes("barkyn.it")) return "IT";
    if (hostname.includes("barkyn.pt")) return "PT";
    if (hostname.includes("barkyn.es")) return "ES";

    return "PT";
  }

  // Helper function to determine step on Tasting Journey
  const determineStep = (subscriptionProductIds, country) => {
    if (!CONFIG[country]) return 0;

    const userIdsAsText = subscriptionProductIds.map((id) => String(id));

    const countryConfig = CONFIG[country];

    // Check for each step
    if (
      countryConfig.step1 &&
      countryConfig.step1.some((id) => userIdsAsText.includes(String(id)))
    ) {
      return 1;
    }

    if (
      countryConfig.step2 &&
      countryConfig.step2.some((id) => userIdsAsText.includes(String(id)))
    ) {
      return 2;
    }

    if (
      countryConfig.step3 &&
      countryConfig.step3.some((id) => userIdsAsText.includes(String(id)))
    ) {
      return 3;
    }

    return 0; // Nothing found
  };

  const renderBannerHTML = (step, country) => {
    const texts = {
      IT: {
        title: "Ti diamo il benvenuto nel Percorso di Degustazione",
        tastingJourney: "Percorso di Degustazione",
        stepLabel: `${step} di 3 offerte`,
        messages: {
          1: "Ordina entro la fine di dicembre per ricevere in omaggio il Food Topping Beef & Collagen",
          2: "Ordina entro la fine di gennaio per ricevere in omaggio la Carne Fresca",
          3: "Ordina entro la fine di febbraio per ricevere in omaggio il Integratore per Immunity Boost",
          default: "Completa i tuoi ordini per ricevere regali esclusivi!",
        },
      },
      ES: {
        title: "Bienvenido/a a la Experiencia de Degustación",
        tastingJourney: "Experiencia de Degustación",
        stepLabel: `${step} de 3 ofertas`,
        messages: {
          1: "Pide antes de finales de diciembre para recibir de regalo el Food Topping Beef & Collagen",
          2: "Pide antes de finales de enero para recibir de regalo Carne Fresca",
          3: "Pide antes de finales de febrero para recibir de regalo el Integratore per Immunity Boost",
          default: "Completa tus pedidos para recibir regalos exclusivos!",
        },
      },
      PT: {
        title: "Bem-vindo à Experiência de Degustação",
        tastingJourney: "Experiência de Degustação",
        stepLabel: `${step} de 3 ofertas`,
        messages: {
          1: "Encomende até final de dezembro para receber o Food Topping Beef & Collagen de oferta",
          2: "Encomende até final de janeiro para receber Carne Fresca de oferta",
          3: "Encomende até final de fevereiro para receber o Suplemento Immunity Boost de oferta",
          default: "Complete suas encomendas para receber ofertas exclusivas!",
        },
      },
    };

    const progressImages = {
      1: "https://cdn.shopify.com/s/files/1/0612/1517/8809/files/desktop_1.png?v=1764697224",
      2: "https://cdn.shopify.com/s/files/1/0612/1517/8809/files/desktop_2.png?v=1764697225",
      3: "https://cdn.shopify.com/s/files/1/0612/1517/8809/files/desktop_3.png?v=1764697224",
    };

    const mobileProgressImages = {
      1: "https://cdn.shopify.com/s/files/1/0612/1517/8809/files/mobile_1.png?v=SEU_V",
      2: "https://cdn.shopify.com/s/files/1/0612/1517/8809/files/mobile_2.png?v=SEU_V",
      3: "https://cdn.shopify.com/s/files/1/0612/1517/8809/files/mobile_3.png?v=SEU_V",
    };

    const content = texts[country] || texts["IT"];
    const message = content.messages[step] || content.messages.default;
    const imageUrl = progressImages[step] || progressImages[1];
    const mobileImageUrl =
      mobileProgressImages[step] || mobileProgressImages[1];

    const stepLabelContentHTML = `
            <strong>${content.tastingJourney}</strong> • <span>${content.stepLabel}</span>
        `;

    return `
            <div class="loop-cp-streak-banner loop-banner loop-grid-item tj-card-wrapper">
                <div>
                    <div class="tj-header-row">
                        <h3 class="loop-text-p1 mb-1 loop-cp-stream-work-done-text">
                            ${content.title}
                        </h3>
                        
                        <div class="loop-cp-streak-no-count tj-desktop-label" style="font-size: 14px; font-weight: 400; white-space: nowrap;">
                            ${stepLabelContentHTML}
                        </div>
                    </div>

                    <div class="tj-content-row tj-mobile-stack">
                        
                        <div class="tj-message-content tj-mobile-order-1" style="flex: 1 1 40%;">
                            <div class="loop-text-p1 mt-2 tj-message-box">
                                ${message}
                            </div>
                        </div>
                        
                        <div class="tj-label-content tj-mobile-order-2">
                             ${stepLabelContentHTML}
                        </div>
                        
                        <div class="tj-img-container tj-mobile-order-3">
                            <img src="${imageUrl}" alt="Desktop Step ${step}" class="tj-progress-img tj-desktop-img">
                            <img src="${mobileImageUrl}" alt="Mobile Step ${step}" class="tj-progress-img tj-mobile-img"> 
                        </div>

                    </div>

                </div>
            </div>`;
  };

  // --- API ---
  return {
    init: function (containerSelector, subscriptionLineItems) {
      // Guard: Container exists
      const container = document.querySelector(containerSelector);

      if (!container) {
        return;
      }

      // Guard: Banner has not been injected yet
      if (
        container.dataset.tastingJourneyInjected === "true" ||
        container.querySelector(".loop-cp-streak-banner")
      ) {
        return;
      }

      // Add mark that we've injected the banner
      container.dataset.tastingJourneyInjected = "true";

      const country = getCountry();

      let productIds = [];
      // Extract product IDs
      if (subscriptionLineItems && subscriptionLineItems.length > 0) {
        if (typeof subscriptionLineItems[0] === "object") {
          productIds = subscriptionLineItems.map(
            (item) =>
              item.productId ||
              item.product_id ||
              item.variantId ||
              item.variant_id
          );
        } else {
          productIds = subscriptionLineItems;
        }
      }

      const step = determineStep(productIds, country);

      if (step > 0) {
        const bannerHTML = renderBannerHTML(step, country);

        // 'afterbegin' inserts the banner right at the start of the container, without destroying events of other elements
        container.insertAdjacentHTML("afterbegin", bannerHTML);
      } else {
        // If there shouldn't be a banner, we remove the mark to allow trying again if products change
        delete container.dataset.tastingJourneyInjected;
      }
    },
  };
})();
